import { render, staticRenderFns } from "./RelatorioCargaDescarga.vue?vue&type=template&id=447c28dd"
import script from "./RelatorioCargaDescarga.vue?vue&type=script&lang=js"
export * from "./RelatorioCargaDescarga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports